import en from './locales/en';
import de from './locales/de';
import bg from './locales/bg';

export default { en, de, bg };
